import Vector from "victor";
import WhiteboardControllerInterface from "../types/WhiteboardControllerInterface";
import Rect from "../types/Rect";

/**
 * Shows a box while the user is dragging, from the mouse down point to the
 * current mouse point.
 */
export default class DragRectController {
  originalScreenPoint = new Vector(0, 0);
  lastScreenPoint = new Vector(0, 0);
  isPointerDown = false;
  isActive = false;

  dragRectDiv: HTMLDivElement;

  constructor() {
    this.dragRectDiv = document.createElement("div");
    this.dragRectDiv.className = "SelectTool_DragRect";
  }

  applyStyle() {
    if (!this.dragRectDiv.parentElement) return;
    const rect = new Rect(
      this.originalScreenPoint,
      this.lastScreenPoint
    ).translated(
      new Vector(
        this.dragRectDiv.parentElement.offsetLeft,
        this.dragRectDiv.parentElement.offsetTop
      )
    );
    this.dragRectDiv.style.left = `${rect.minX}px`;
    this.dragRectDiv.style.top = `${rect.minY}px`;
    this.dragRectDiv.style.width = `${rect.width}px`;
    this.dragRectDiv.style.height = `${rect.height}px`;
  }

  abort() {
    this.isActive = false;
    this.isPointerDown = false;
    this.applyStyle();
    if (this.dragRectDiv.parentElement) {
      this.dragRectDiv.parentElement?.removeChild(this.dragRectDiv);
    }
  }

  /* Event handlers */

  onPointerDown = (wb: WhiteboardControllerInterface, screenPoint: Vector) => {
    this.isPointerDown = true;
    this.originalScreenPoint = screenPoint;
    this.lastScreenPoint = this.originalScreenPoint;
    this.isActive = true;
    wb.el.appendChild(this.dragRectDiv);
    this.applyStyle();
  };

  // eslint-ignore-next-line
  onPointerMove = (wb: WhiteboardControllerInterface, screenPoint: Vector) => {
    if (!this.isPointerDown) return;
    this.lastScreenPoint = screenPoint;
    this.applyStyle();
  };

  // eslint-ignore-next-line
  onPointerUp = () => {
    this.abort();
  };
}
